import React, { useContext, useRef, useState } from 'react';
import { LoginLink } from 'app/modules/auth/components/login';
import { RegistrationLink } from 'app/modules/auth/components/registration';
import { ResetLink } from 'app/modules/auth/components/reset';
import { connect } from 'react-redux';
import { getConsiderProductPriceByTypePrice } from 'app/functions/app';
import { ShopCaseLink } from 'app/modules/shop/components/shopCase';
import _ from 'underscore';
import { Searchbar } from 'app/components/Searchbar';
import { ConnectedCart } from 'app/components/Cart';
import { ConnectedProfile } from 'app/components/Profile';
import { ConnectedMenuModal } from '../menuMobile/MenuMobile';
import { Context } from '../../index';
import { LogoLink } from '../Logo';
import {
    HeaderInformationConnect,
    NavbarHeaderContainer,
} from './NavbarHeader';
import { useDesktop } from 'app/hooks/useDesktop';
import { useHeightWatcher } from 'app/hooks/useHeightWatcher';
import { NavbarNav, NavbarNavCompact } from 'app/components/navbar/NavbarNav';
import { MenuCompactModalConnect } from 'app/components/MenuCompactModal';
import { useToggleCompactMenu } from 'app/hooks/useToggleCompactMenu';
import { useSticky } from 'app/hooks/useSticky';

export const MenuTypes = {
    full: 0,
    compact: 1,
};

const SearchBarContainer = ({ childrenTypes, activeType }) => {
    const [isShowActions, setIsShowActions] = useState(true);
    const wrapperRef = useRef();
    const containerRef = useRef();
    const {
        isSticky: [isSticky, setSticky],
        contentWrapper,
        settings: {
            navbar: { settings: navbarSettings },
        },
    } = useContext(Context);
    useSticky(wrapperRef, contentWrapper, setSticky);
    useHeightWatcher(wrapperRef, 'nav');
    useToggleCompactMenu();
    const isDesktop = useDesktop();
    const isCompact = navbarSettings.type === MenuTypes.compact;
    return (
        <div
            className={'header'}
            onMouseEnter={() => setIsShowActions(true)}
            onMouseLeave={() => setIsShowActions(false)}
        >
            <div ref={wrapperRef} className={'searchbar-container__wrapper'}>
                <div ref={containerRef} className={'searchbar-container'}>
                    <LogoLink className={'searchbar-container__logo'} />
                    {isCompact ? (
                        <>
                            {isSticky && isDesktop ? (
                                <NavbarNavCompact
                                    links={navbarSettings.links}
                                />
                            ) : null}
                            <HeaderInformationConnect
                                className={'header-information__extra_compact'}
                            />
                        </>
                    ) : (
                        <>
                            <ConnectedMenuModal />
                            <Searchbar />
                        </>
                    )}
                    {isDesktop ? (
                        isCompact && isSticky ? (
                            <ConnectedCart />
                        ) : (
                            <>
                                <ConnectedProfile />
                                <ConnectedCart />
                            </>
                        )
                    ) : null}
                </div>
                {isCompact ? (
                    !isDesktop || !isSticky ? (
                        <NavbarNavCompact links={navbarSettings.links} />
                    ) : null
                ) : (
                    <NavbarNav
                        childrenTypes={childrenTypes}
                        activeType={activeType}
                    />
                )}
            </div>
            <MenuCompactModalConnect isShowActions={isShowActions} />
        </div>
    );
};

const Navbar = ({
    user,
    openShopCase,
    products,
    openLogin,
    point,
    activeType,
    childrenTypes,
    isAuthRequired,
}) => {
    const onClickItemShop =
        user || !isAuthRequired
            ? openShopCase
            : () => {
                  openLogin(openShopCase);
              }; // todo ?

    let product_total_price_sum = 0,
        product_total_qty = 0;
    _.each(products, (i) => (product_total_qty += Number(i.qty)));
    _.each(
        products,
        (i) =>
            (product_total_price_sum +=
                Number(i.qty) *
                getConsiderProductPriceByTypePrice(
                    i,
                    point.type_price_json,
                    i.qty,
                    user ? user.discount : 0
                ).price_consider)
    );
    return (
        <>
            <NavbarHeaderContainer />
            <SearchBarContainer
                activeType={activeType}
                childrenTypes={childrenTypes}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.authState.user,
        currency: state.pointsState.currency,
        isAuthRequired: state.pointsState.isAuthRequired,
        products: state.shopState.shopCase.products,
        point: state.shopState.order.point,
        activeType: state.shopState.active_type,
        childrenTypes: state.shopState.children,
    };
};

const dispatchToProps = (dispatch) => {
    return {
        openLogin: () => {
            dispatch({
                type: 'openMiniModal',
                header: 'Вход',
                children: <LoginLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        openRegistration: () => {
            dispatch({
                type: 'openMiniModal',
                header: 'Регистрация',
                children: <RegistrationLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        openReset: () => {
            dispatch({
                type: 'openMiniModal',
                header: 'Восстановление пароля',
                children: <ResetLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        openShopCase: () => {
            dispatch({
                type: 'openRightModal',
                HeadItem: ['Корзина'],
                children: <ShopCaseLink />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
    };
};

export const NavbarLink = connect(mapStateToProps, dispatchToProps)(Navbar);
